import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './MatureIndicator.scss';
var MatureIndicator = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("span", null, t('deviation.details.mature'))));
};
MatureIndicator.displayName = 'MatureIndicator';
export default MatureIndicator;
//# sourceMappingURL=MatureIndicator.js.map